import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-select-box',
    templateUrl: './select-box.component.html',
    styleUrls: ['./select-box.component.css'],
    standalone: false
})
export class SelectBoxComponent implements OnInit {
  @Input() value: string;

  constructor() {
  }

  ngOnInit() {
  }
}
